export default __webpack_public_path__ + "static/media/crypto.6d03ea68.png";